<template>
    <div class="h-100 hyper-login" :style="`background-image:url(${backgrounImage});`">
        <div class="logo">
            <img
                :src="logoImage"
                :onError='`this.onerror=null;this.src="${logoBaseUrl}/hyperbilling-light-logo.png"`'
                :alt="VUE_APP_NAME"
            >
        </div>
        <div class="auth-wrapper">
            <div class="auth-inner py-1 px-1">
                <b-card class="mb-0">
                    <b-card-text>
                        <b-link class="brand-logo">
                            <h2 class="brand-text" style="margin:auto 0">
                                <span style="font-size:xx-large">
                                    HyperBilling
                                </span>
                            </h2>
                        </b-link>
                    </b-card-text>
                    <b-card-title class="mb-1">
                        Forgot Password?
                        <feather-icon
                            class="text-warning"
                            icon="LockIcon"
                            size="17"
                        />
                    </b-card-title>
                    <b-card-text class="mb-2">
                        Enter your email and we'll send you instructions to reset your password
                    </b-card-text>

                    <!-- form -->
                    <validation-observer ref="simpleRules">
                        <b-form
                            class="auth-forgot-password-form mt-2"
                            @submit.prevent="validationForm"
                        >
                            <!-- email -->
                            <b-form-group
                                label-for="forgot-password-email"
                            >
                                <validation-provider
                                    #default="{ errors }"
                                    name="Email"
                                    rules="required|email"
                                >
                                <b-form-input
                                    id="forgot-password-email"
                                    v-model="userEmail"
                                    :state="errors.length > 0 ? false:null"
                                    name="forgot-password-email"
                                    placeholder="Email Address"
                                />
                                <small class="text-danger">
                                    {{ errors[0] }}
                                </small>
                                </validation-provider>
                            </b-form-group>

                            <!-- submit button -->
                            <b-button
                                variant="primary"
                                block
                                type="submit"
                            >
                                Send reset link
                            </b-button>
                        </b-form>
                    </validation-observer>

                    <b-card-text class="text-center mt-2">
                        <b-link :to="{name:'auth-login'}">
                            <feather-icon icon="ChevronLeftIcon" />
                            Back to login
                        </b-link>
                    </b-card-text>

                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import md5 from 'md5'
import { ref, getCurrentInstance } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import useEnvString from '@/composables/useEnvString'
export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    setup () {
        const vm = getCurrentInstance().proxy
        const store = vm.$store

        const {
            VUE_APP_HYPER_V3_CONTENT,
            VUE_APP_NAME,
            VUE_APP_NAMESPACE,
            VUE_APP_SERVICE
        } = useEnvString()
        const userEmail = ref('')
        const required = ref('')
        const email = ref('')
        const logoBaseUrl = VUE_APP_HYPER_V3_CONTENT + '/logo'
        const logoImage = `${logoBaseUrl}/logo/${md5(VUE_APP_NAMESPACE + '-' + VUE_APP_SERVICE)}.png`
        const backgrounImage = `${logoBaseUrl}/bg/${md5(VUE_APP_NAMESPACE + '-' + VUE_APP_SERVICE)}.png`
        const locale = ref(localStorage.getItem('locale'))
        const validationForm = () => {
            vm.$refs.simpleRules.validate().then(success => {
                if (success) {
                    store.dispatch('resetPassword', { email: userEmail.value })
                }
            })
        }
        return {
            VUE_APP_NAME,
            logoBaseUrl,
            logoImage,
            backgrounImage,
            locale,
            userEmail,
            required,
            email,
            validationForm
        }
    }
}
</script>

<style lang="scss">
/** LOGIN FORM */
.auth-wrapper {
    position: relative;
    max-width: 525px;
    margin: 0 auto;
    .auth-inner {
        margin: auto;
    }
}
</style>
